import { dataLightningSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLightningSolid = /*#__PURE__*/createIcon(dataLightningSolid)
export default IconLightningSolid
